import request from '@/utils/request'

const bpmModel = window.context.bpmModel
const bpmRunTime = window.context.bpmRunTime
const portal = window.context.portal

//根据流程实例ID获取相关信息
export function getRelatedInformationById(id) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/getRelatedInformationById?id=${id}`,
    method: 'get',
  })
}

//获取相关信息的阅读记录列表
export function getByRecordInstId(data) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/getByRecordInstId`,
    method: 'post',
    data,
  })
}

//获取催办记录列表
export function getUrgentById(data) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/getUrgrntById`,
    method: 'post',
    data,
  })
}

//获取处理记录列表
export function getOpinionsById(data) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/instanceFlowOpinions`,
    method: 'get',
    params: data,
  })
}

//获取处理记录列表-可能回退的接口
export function getOpinionsById2(data) {
  return request({
    url: `${bpmRunTime}/runtime/instance/v1/instanceFlowOpinions2`,
    method: 'get',
    params: data,
  })
}

export default {
  getRelatedInformationById,
  getUrgentById,
  getOpinionsById,
  getOpinionsById2,
  getByRecordInstId,
}
